<div style="padding: 35px">
    <p
        *ngIf="isOpInstructionAttachment"
        class="op_instruction_description">
        {{ 'PAGE.GENERAL.LABEL_DIALOG_OP.BT' | translate }}
    </p>
    <sera-table
        class="sera-attachments-table"
        [customSeraCell]="customSeraCell"
        [showToolbarButtons]="true"
        [disableAllTableActions]="attachmentsLogicService.uploadingFile"
        [content]="attachmentsTableContent"
        [isEditMode]="($analysisIsEditMode | async)!">
    </sera-table>
</div>
<div class="sera-popup-footer">
    <div class="sera-attachment-info">
        <sera-icon [class]="'ci ci-information sera-info-icon'"></sera-icon>
        <label>{{ 'PAGE.ATTACHMENT.DISCARD_INFO.LBL' | translate }}</label>
    </div>

    <div class="sera-attachment-buttons">
        <ds-button
            [variant]="'ghost'"
            (click)="closePopupEvent.emit()"
            (keydown.enter)="closePopupEvent.emit()">
            {{ 'PAGE.GENERAL.CLOSE.BT' | translate }}
        </ds-button>
        <ds-button
            *ngIf="$analysisIsEditMode | async"
            [variant]="'primary'"
            [disabled]="attachmentsLogicService.uploadingFile"
            (click)="onSubmit()"
            (keydown.enter)="onSubmit()">
            {{ 'PAGE.GENERAL.SAVE.BT' | translate }}
        </ds-button>
    </div>
</div>

<ng-template
    #customSeraCell
    let-data="rowData">
    <div>
        <div
            *ngIf="!isOpInstructionAttachment && data.attachmentType === 'URL'"
            [ngClass]="{ 'p-disabled': attachmentsLogicService.uploadingFile, 'attachment-url-cell-no-gap': !isEditMode }"
            class="attachment-url-cell">
            <sera-input-text
                [title]="data.url"
                *ngIf="$analysisIsEditMode | async"
                style="width: 100%"
                [(ngModel)]="data.url">
            </sera-input-text>
            <span
                [title]="data.url"
                *ngIf="!isEditMode"
                >{{ data.url }}</span
            >
        </div>

        <div
            *ngIf="isOpInstructionAttachment && data.instructionType === 'URL'"
            [ngClass]="{ 'p-disabled': attachmentsLogicService.uploadingFile, 'attachment-url-cell-no-gap': !isEditMode }"
            class="attachment-url-cell">
            <sera-input-text
                [title]="data.attachment.url"
                *ngIf="$analysisIsEditMode | async"
                style="width: 100%"
                [(ngModel)]="data.attachment.url">
            </sera-input-text>
            <span
                [title]="data.attachment.url"
                *ngIf="!isEditMode"
                >{{ data.attachment.url }}</span
            >
        </div>

        <div
            *ngIf="isOpInstructionAttachment && data.instructionType === 'FILE'"
            class="attachment-upload-cell">
            <input
                type="file"
                #fileInput
                style="display: none"
                (change)="handleFileInput($event, data)" />
            <span
                [title]="data.attachment.filename"
                [ngClass]="{
                    'uploading-text': data.isUploading,
                    'p-disabled': !data.isUploading && attachmentsLogicService.uploadingFile
                }">
                {{ data.isUploading ? ('ATTACHMENTS_UPLOADING.LBL' | translate) : data.attachment.filename }}
            </span>
            <ds-button
                *ngIf="$analysisIsEditMode | async"
                [disabled]="attachmentsLogicService.uploadingFile"
                (click)="fileInput.click()"
                variant="ghost"
                [icon]="data.isUploading ? 'loader' : 'upload'"
                size="sm"></ds-button>
        </div>

        <div
            *ngIf="!isOpInstructionAttachment && data.attachmentType === 'UPLOAD'"
            class="attachment-upload-cell">
            <input
                type="file"
                #fileInput
                style="display: none"
                (change)="handleFileInput($event, data)" />
            <span
                [title]="data.filename"
                [ngClass]="{
                    'uploading-text': data.isUploading,
                    'p-disabled': !data.isUploading && attachmentsLogicService.uploadingFile
                }">
                {{ data.isUploading ? ('ATTACHMENTS_UPLOADING.LBL' | translate) : data.filename }}
            </span>
            <ds-button
                *ngIf="$analysisIsEditMode | async"
                [disabled]="attachmentsLogicService.uploadingFile"
                (click)="fileInput.click()"
                variant="ghost"
                [icon]="data.isUploading ? 'loader' : 'upload'"
                size="sm"></ds-button>
        </div>
    </div>
</ng-template>
